import React from 'react';
import PropTypes from 'prop-types';

import { Text } from 'components';

const Label = ({
  name,
  ...props
}) => (
  !name.includes('x-label:') &&
  <Text value={name} {...props} />
);

Label.propTypes = {
  name: PropTypes.string.isRequired
};

export default Label;



// WEBPACK FOOTER //
// ./src/containers/Label/Label.js